import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';
import {UserSortField as UserSortFields} from 'src/openapi/admin/models/UserSortField';

import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {UserSearchCriteria} from 'src/openapi/admin/models/UserSearchCriteria';
import type {UserSearchFiltering} from 'src/openapi/admin/models/UserSearchFiltering';
import type {UserSortField} from 'src/openapi/admin/models/UserSortField';

export const userSearchResultStateSlice = getCachedTableStateSlice<
    UserSearchCriteria,
    UserSortField,
    UserSearchFiltering
>('userSearchResultState', UserSortFields.EMAIL);

export const userSearchResultStateActions = userSearchResultStateSlice.actions;
export const userSearchResultStateSelector:
CachedTableStateSelector<UserSearchCriteria, UserSortField, UserSearchFiltering> =
    state => state.userSearchResult.state;
